<button (click)="remove()" class="toast-close-button" aria-label="Close">
  <span aria-hidden="true">&times;</span>
</button>
<div *ngIf="title" class="title" [attr.aria-label]="title">
  {{ title }}
</div>
<div role="alertdialog" aria-live="polite" [attr.aria-label]="'プランをアップグレードされる方はこちら'">
  <a (click)="moveToPlan($event)">プランをアップグレードされる方はこちら</a>
</div>
